import React, { useState, useEffect } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, Typography, Box, Paper, Tooltip } from '@mui/material';
import sevenNowFormLogo from '../../../../public/assets/img/form-7Now.svg';
import './GetStartedPage.scss';
import { useNavigate } from 'react-router-dom';
import { MERCHANT_PORTAL, SIGN_UP_FOR_MERCHANT_ACCOUNT, BUSINESS_LEGAL_ENTITY_NAME, LEGAL_ADDRESS, CITY, STATE, ZIP_CODE, MERCHANT_SIGNEE_NAME, SIGNEE_EMAIL, SIGNEE_TITLE, BILLING_CONTACT_NAME, BILLING_EMAIL, LOCATION_LIST, FULL_LIST, LIST_OF_ADDRESSES, ACCEPTED_FORMATS, MAX_FILE_SIZE, CANCEL, SIGN_UP, SEND_A_COPY_OF_MY_RESPONSES, DRAG_FILE_OR, OR, CHOOSE_FILE, FILE_SIZE_ERROR, FILE_TYPE_ERROR, FILE_CONTENT_ERROR, PLEASE_ENTER, ADDRESS_LIST_ERROR, AGREE_TEXT, PRIVACY_POLICY, AND, TERMS_OF_USE, ADDITIONAL_INFORMATION } from '../../../constants/getStartedConstants';
import { useDropzone } from 'react-dropzone';
import infoIcon from '../../../../public/assets/img/utility-information.svg';
import { getStartedPageRequest, getStartedPageReset } from '../../../redux/actions/getStartedAction';
import { useDispatch, useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { N_A, BUTTON_CLICK } from '../../../constants/mixPannelConstants';
import { getStartedSaga } from '../../../redux/saga/getStartedPageSelector';
import { handleInputChange, isValidEmail, sanitizeFileName } from '../../../shared/utils/format.helpers';


const GetStartedPage = () => {

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const getStartedData = useSelector(getStartedSaga);
	const [businessLegalName, setBusinessLegalName] = useState('');
	const [businessLegalNameError, setBusinessLegalNameError] = useState(false);
	const [legalAddress, setLegalAddress] = useState('');
	const [legalAddressError, setLegalAddressError] = useState(false);
	const [city, setCity] = useState('');
	const [cityError, setCityError] = useState(false);
	const [state, setState] = useState('');
	const [stateError, setStateError] = useState(false);
	const [zipCode, setZipCode] = useState('');
	const [zipCodeError, setzipCodeError] = useState(false);
	const [merchantSigneeName, setMerchantSigneeName] = useState('');
	const [merchantSigneeNameError, setMerchantSigneeNameError] = useState(false);
	const [signeeEmail, setSigneeEmail] = useState('');
	const [signeeEmailError, setSigneeEmailError] = useState(false);
	const [signeeTitle, setSigneeTitle] = useState('');
	const [signeeTitleError, setSigneeTitleError] = useState(false);
	const [billingContactName, setBillingContactName] = useState('');
	const [billingContactNameError, setBillingContactNameError] = useState(false);
	const [billingEmail, setBillingEmail] = useState('');
	const [billingEmailError, setBillingEmailError] = useState(false);
	const [additionalInformation, setAdditionalInformation] = useState('');
	const [sendCopy, setSendCopy] = useState(true);
	const [listOfAddresses, setListOfAddresses] = useState('');
	const [uploadedFile, setUploadedFile] = useState(null);
	const [fileSizeError, setFileSizeError] = useState(false);
	const [fileTypeError, setFileTypeError] = useState(false);
	const [fileContentError, setFileContentError] = useState(false);
	const [addressError, setAddressError] = useState(false);
	const [tooltipOpen, setTooltipOpen] = React.useState(false);
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

	useEffect(() => {
		return () => {
		  dispatch(getStartedPageReset());
		};
	}, [dispatch]);

	useEffect(() => {
		if (getStartedData?.responseData?.data?.message === 'HTML content detected in field') {
			setFileContentError(true);
		} else if (getStartedData?.responseData?.data?.message === 'The current file is more than 2MB, please upload a file lesser than 2MB') {
			setFileSizeError(true);
		} else if (getStartedData?.responseData?.message === 'you are successfully onboarded.'){
			navigate('/intakeformsubmitted');
		}
	}, [getStartedData, navigate]);

	const handleZipChange = (event) => {
		let error = false;
		const { value } = event.target;
		const filteredValue = value.replace(/[^0-9-]/g, '');
		const zipPattern = /^\d{5}(-\d{4})?$/;
		const isValid = zipPattern.test(filteredValue) || filteredValue === '';
		setZipCode(filteredValue);
		setzipCodeError(!isValid && filteredValue !== '');
		validateForm();
	};

	const handleSubmit = () => {
		let error = false;
	
		if (!error) {
			const getStarted = {
				businessLegalName,
				legalAddress,
				city,
				state,
				zipCode,
				merchantSigneeName,
				signeeEmail,
				signeeTitle,
				billingContactName,
				billingEmail,
				fileLocation: listOfAddresses,
				//storeAddresses: listOfAddresses,
				additionalInformation
			}; 
			const finalFormData = new FormData();
			finalFormData.append('getStartedModel', new Blob([JSON.stringify(getStarted)], {type: 'application/json'}));
			if (uploadedFile) {
				finalFormData.append('file', uploadedFile);
			}
			dispatch(getStartedPageRequest(finalFormData));
		}
		mixpanel.track(BUTTON_CLICK, {
			buttonName: 'sign up button on get started page',
			EventTime: new Date().toUTCString(),
			PageName: N_A,
			timeSpent: N_A
		});
	};
	const handleCancel = () => {
		mixpanel.track(BUTTON_CLICK, {
			buttonName: 'cancel button on get started page',
			EventTime: new Date().toUTCString(),
			PageName: N_A,
			timeSpent: N_A
		});
		navigate('/');
	}
	const privacyPolicyHandler = (e) => {
        window.open(process.env.PRIVACY_URL, '_blank');
        e.preventDefault();
    }
	const termsOfUseHandler = (e) => {
        window.open(process.env.TERMS_URL, '_blank');
        e.preventDefault();
    }
	const removeFile = () => {
		setUploadedFile(null);
		setFileTypeError(false);
		setFileSizeError(false);
		setFileContentError(false);
		if(listOfAddresses){
			setAddressError(false);
		}else { setAddressError(true); }
	};

	const toggleTooltip = () => {
		if (tooltipOpen === false) {
			setTooltipOpen(true);
		} else {
			setTooltipOpen(false);
		}
	};
	const {
		getRootProps,
		getInputProps,
		isDragActive
	} = useDropzone({
		accept: {
			'text/csv': ['.csv'],
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
		},
		maxSize: 2 * 1024 * 1024, // 2 MB
		multiple: false,
		onDrop: (acceptedFiles, fileRejections) => {
			let isTypeError = false;
			let isSizeError = false;

			fileRejections.forEach(rejection => {
				rejection.errors.forEach(error => {
					if (error.code === 'file-invalid-type') {
						isTypeError = true;
					}
					if (error.code === 'file-too-large') {
						isSizeError = true;
					}
				});
			});

			if (isTypeError) {
				setFileTypeError(true);
				setFileSizeError(false);
				setFileContentError(false);
			} else if (isSizeError) {
				setFileTypeError(false);
				setFileSizeError(true);
				setFileContentError(false);
			} else {
				setFileTypeError(false);
				setFileSizeError(false);
				setFileContentError(false);
				const file = acceptedFiles[0];
				const sanitizedFileName = sanitizeFileName(file.name);
          		const sanitizedFile = new File([file], sanitizedFileName, { type: file.type });
				if (file.path) {
					sanitizedFile.path = sanitizedFile.name;
				}
          		setUploadedFile(sanitizedFile);
				setAddressError(false);
			}
			if(listOfAddresses){
				setAddressError(true);
			}else { setAddressError(false); }
		}
	},[]);

	const validateForm = () => {
		const isFormValid = (
			!signeeEmailError && !businessLegalNameError && !legalAddressError && !cityError &&
			!stateError && !zipCodeError && !merchantSigneeNameError && !signeeTitleError && !billingContactNameError && !billingEmailError &&
			!fileTypeError && !fileSizeError && !fileContentError && !addressError && signeeEmail &&
			businessLegalName &&legalAddress && city && state && zipCode && merchantSigneeName && signeeTitle && billingContactName &&
			billingEmail && (listOfAddresses || uploadedFile) 
		);
		setIsSubmitDisabled(!isFormValid);
	};
	useEffect(() => {
		validateForm();
		
	}, [ signeeEmail, businessLegalName, legalAddress, city, state, zipCode, merchantSigneeName, signeeTitle,
		billingContactName, billingEmail, fileTypeError, fileSizeError, fileContentError, uploadedFile ,addressError,listOfAddresses
	]);
	

	const validateBusinessLegalInput =(e)=>{
		 let error = false;
		handleInputChange(e.target.value, setBusinessLegalName, setBusinessLegalNameError);
		validateForm();
	}
	const validateLegalAddressInput =(e)=>{
		let error = false;
	   handleInputChange(e.target.value, setLegalAddress, setLegalAddressError);
	   validateForm();
   }
	const validateCityInput =(e)=>{
		let error = false;
		handleInputChange(e.target.value, setCity, setCityError);
	   validateForm();
   }
   const validateStateInput =(e)=>{
		let error = false;														
		handleInputChange(e.target.value, setState, setStateError);
		validateForm();
	}
	const validateSigneeName =(e)=>{
		let error = false;
		handleInputChange(e.target.value, setMerchantSigneeName, setMerchantSigneeNameError);
		validateForm();
	}
	const validateSigneeEmail =(e)=>{
		let error = false;
		handleInputChange(e.target.value, setSigneeEmail, setSigneeEmailError, true);
		validateForm();
	}
	const validateSigneeTitle =(e)=>{
		let error = false;
		handleInputChange(e.target.value, setSigneeTitle, setSigneeTitleError);
		validateForm();
	}
	const validateBillingName =(e)=>{
		let error = false;
		handleInputChange(e.target.value, setBillingContactName, setBillingContactNameError);
		validateForm();
	}
	const validateBillingEmail =(e)=>{
		let error = false;
		handleInputChange(e.target.value, setBillingEmail, setBillingEmailError, true);
		validateForm();
	}
	const validateAddresses =(e)=>{
		let error = false;
		 
		handleInputChange(e.target.value, setListOfAddresses, setAddressError, false, true );
		if (uploadedFile === null && !listOfAddresses.trim()) { setAddressError(true); error = true; } 
		else if (uploadedFile && listOfAddresses.trim()) { setAddressError(true); error = true;} else { setAddressError(false); }
		validateForm();
	}

  return (
	<>
		<div className='get-started-page'>

			<div className='text-align-center margin36 get-started-heading'>
				<img src={sevenNowFormLogo} alt='SevenNow header Logo' className='text-align-center' />
				<Typography variant='h5' className='header-text' >{MERCHANT_PORTAL}</Typography>
			</div>

			<Box className='formContainer'>
				<Typography variant='h5' className='text-align-left signup-text'>{SIGN_UP_FOR_MERCHANT_ACCOUNT}</Typography>
				<TextField 
					className='inputField'
					fullWidth 
					label={BUSINESS_LEGAL_ENTITY_NAME}
					variant='outlined'
					value={businessLegalName} 
					onChange={validateBusinessLegalInput}
					onBlur={validateBusinessLegalInput}
					error={businessLegalNameError}
					helperText={businessLegalNameError ? `${PLEASE_ENTER} ${BUSINESS_LEGAL_ENTITY_NAME}` : ''}
				/>
				<TextField
					className='inputField' 
					fullWidth label={LEGAL_ADDRESS}	
				 	variant='outlined' 
				 	value={legalAddress}
					onChange={validateLegalAddressInput}
					onBlur={validateLegalAddressInput}
					error={legalAddressError}
					helperText={legalAddressError ? `${PLEASE_ENTER} ${LEGAL_ADDRESS}` : ''}
				 />
				<div className='vertical-container'>
					<TextField 
						className='inputField' 
						fullWidth label={CITY} 
						variant='outlined'
						value={city} 
						onChange={validateCityInput}
						onBlur={validateCityInput}
						error={cityError}
						helperText={cityError ? `${PLEASE_ENTER} ${CITY}` : ''}
					/>
					<TextField 
						className='inputField' 
						fullWidth label={STATE}
						variant='outlined' 
						value={state} 
						onChange={validateStateInput}
						onBlur={validateStateInput}
						error={stateError}
						helperText={stateError ? `${PLEASE_ENTER} ${STATE}`: ''}
					/>
					<TextField
						className='inputField'
						fullWidth
						label={ZIP_CODE}
						variant='outlined'
						value={zipCode}
						onChange={handleZipChange}
						onBlur={handleZipChange}
						error={zipCodeError}
						helperText={zipCodeError ? `${PLEASE_ENTER} ${ZIP_CODE}` : ''}
					/>
				</div>
				<div className='vertical-container'>
					<TextField 
						className='inputField' 
						fullWidth 
						label={MERCHANT_SIGNEE_NAME}
						variant='outlined'  
						value={merchantSigneeName}
						onChange={validateSigneeName}
						onBlur={validateSigneeName}
						error={merchantSigneeNameError}
						helperText={merchantSigneeNameError ? `${PLEASE_ENTER} ${MERCHANT_SIGNEE_NAME}` : ''}
					/>
					<TextField 
						className='inputField' 
						fullWidth label={SIGNEE_EMAIL} 
						variant='outlined'  
						value={signeeEmail}
						onChange={validateSigneeEmail}
						onBlur={validateSigneeEmail}
						error={signeeEmailError}
						helperText={signeeEmailError ? `${PLEASE_ENTER} ${SIGNEE_EMAIL}` : ''}
					/>
				</div>
				<TextField 
					className='inputField' 
					fullWidth label={SIGNEE_TITLE}
					variant='outlined' 
					value={signeeTitle}
					onChange={validateSigneeTitle}
					onBlur={validateSigneeTitle}
					error={signeeTitleError}
					helperText={signeeTitleError ? `${PLEASE_ENTER} ${SIGNEE_TITLE}` : ''}
				/>
				<div className='vertical-container'>
					<TextField 
						className='inputField' 
						fullWidth 
						label={BILLING_CONTACT_NAME}
						variant='outlined' 
						value={billingContactName}
						onChange={validateBillingName}
						onBlur={validateBillingName}
						error={billingContactNameError}
						helperText={billingContactNameError ? `${PLEASE_ENTER} ${BILLING_CONTACT_NAME}` : ''}
					/>
					<TextField 
						className='inputField' 
						fullWidth label={BILLING_EMAIL}
						variant='outlined' 
						value={billingEmail}
						onChange={validateBillingEmail}
						onBlur={validateBillingEmail}
						error={billingEmailError}
						helperText={billingEmailError ? `${PLEASE_ENTER} ${BILLING_EMAIL}` : ''}
					/>
				</div>
				<Typography variant='h5' className='list-text  text-align-left'>{LOCATION_LIST}</Typography>
				<Typography variant='h5' className='list-subtitle-text  text-align-left'>{FULL_LIST}</Typography>
				<Box className='location-container'>
					<Paper elevation={3} className='width49'>
						<TextField
							fullWidth
							multiline
							rows={4}
							variant='outlined'
							placeholder={LIST_OF_ADDRESSES}
							value={listOfAddresses}
							onChange={validateAddresses}
							onBlur={validateAddresses}
							error={addressError}
						/>
					</Paper>
					<Typography variant='subtitle1' className='width2'>{OR}</Typography>
					<Paper className='width49 file-upload' {...getRootProps()}>
						<input {...getInputProps()} />
						<Typography variant='subtitle1' className='drag-files'>
							{isDragActive ? 'Drop the file here ...' : DRAG_FILE_OR}
						</Typography>
						<Button className='choose-file' component='label'>
							{CHOOSE_FILE}
							<input type='file' hidden {...getInputProps()} />
						</Button>
						{uploadedFile && (
							<Box display='flex' alignItems='center' justifyContent='space-between' my={1}>
							<Typography variant='body2'>{uploadedFile.path}</Typography>
							<Button onClick={removeFile} size='small'>
								<Typography color='error'>X</Typography>
							</Button>
							</Box>
						)}
						<Typography variant='caption'>{ACCEPTED_FORMATS}</Typography>
						<Typography variant='caption'>{MAX_FILE_SIZE}</Typography>
						{fileSizeError && <Typography color='error' className='fontSize12'>{FILE_SIZE_ERROR}</Typography>}
						{fileTypeError && <Typography color='error' className='fontSize12'>{FILE_TYPE_ERROR}</Typography>}
						{fileContentError && <Typography color='error' className='fontSize12'>{FILE_CONTENT_ERROR}</Typography>}
					</Paper>
				</Box>
				{addressError && <Typography color='error' className='fontSize12 margintop12'>{ADDRESS_LIST_ERROR}</Typography>}
				<div className='additional-info-field'>
					<TextField 
						className='inputField'
						fullWidth 
						label={ADDITIONAL_INFORMATION} 
						variant='outlined' 
						value={additionalInformation}
						onChange={e => handleInputChange(e.target.value, setAdditionalInformation)}
					/>
				</div>
				<div className='display-flex'>
					<FormControlLabel
						control={<Checkbox name='checkedC' checked={sendCopy} disabled onChange={e => setSendCopy(e.target.checked)}/>}
						label={
							<Box sx={{ alignItems: 'center' }}>
							{SEND_A_COPY_OF_MY_RESPONSES}
							</Box>
						}
						className='send-response'
					/>
					{/*<ErrorOutlineIcon className='tooltip-icon' onClick={handleTootipClicked}/>*/}

					<Tooltip
						title='Sent to the signee email and billing email'
						PopperProps={{
							disablePortal: true,
						}}
						open={tooltipOpen}
						disableFocusListener
						disableHoverListener
						disableTouchListener
						placement='right'
						arrow
					>
						<img src={infoIcon}  alt="tooltip-Icon" onClick={toggleTooltip} className='tooltip-icon'/>
					</Tooltip>
				</div>
				<div className='margintop16'>
					<Typography className='agree-terms'>{AGREE_TEXT}<span className='agree-terms-bold' onClick={privacyPolicyHandler}>{PRIVACY_POLICY}</span> {AND} <span className='agree-terms-bold' onClick={termsOfUseHandler}>{TERMS_OF_USE}</span></Typography>
				</div>
				<div className='display-flex'>
					<Button className='button' onClick={handleCancel}>
						{CANCEL}
					</Button>
					<Button className='button button-signup' onClick={handleSubmit} disabled={isSubmitDisabled} >
						{SIGN_UP}
					</Button>
				</div>
			</Box>
		</div>
	</>
  );
};

export default GetStartedPage;
